import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.theme = localStorage.getItem("theme") || "light";
    config.headers.currency = localStorage.getItem("currency") || "usd";
    config.headers.language = localStorage.getItem("language") || "en";
    config.headers["x-api-secret"] = process.env.REACT_APP_API_SECRET || "";
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
      // Don't reject - we've handled this error by redirecting
      return Promise.resolve();
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
